import React from "react";
import { MailIcon, MessageCircleIcon } from "lucide-react";
import { ContactForm } from "./ContactForm";
import { InstagramIcon } from "./InstagramIcon";
import { contactInfo, whatsappNumbers } from "../data/content";
export function Contact() {
  return <section id="contacto" className="scroll-mt-20 bg-paper text-ink" data-id="element-44" data-mp="318o3i8pblp2g">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-24 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8 lg:py-32" data-id="element-45" data-mp="2w91mrpaa9qow">
        <div data-id="element-46" data-mp="3szu56tkovutu">
          <p className="text-sm font-medium text-gold-deep" data-id="element-47" data-mp="3szkdn1jzxfm1">Contacto</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-48" data-mp="3owxtznxhb0zx">Agenda una consulta con Fortis</h2>

          <ul className="mt-12 space-y-6" data-id="element-49" data-mp="3k3bhpwv88z4n">
            <li className="flex items-start gap-4" data-id="element-50" data-mp="3f74j6p55upwq">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-51" data-mp="3f48k2xhktv6p">
                <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="bpmdan8y7syy" />
              </span>
              <div data-id="element-53" data-mp="3jvl0gk0fcwlx">
                <span className="block text-sm text-ink/60" data-id="element-54" data-mp="3jv2w103lzc2x">WhatsApp</span>
                <ul className="mt-1 space-y-1" data-id="element-55" data-mp="3jxxi0w29t4yg">
                  {whatsappNumbers.map(number => <li key={number.url} data-id="element-56" data-mp="3b3998vxhl54w">
                      <a href={number.url} target="_blank" rel="noopener noreferrer" className="text-lg font-medium transition-colors duration-150 ease-out hover:text-gold-deep" data-id="element-57" data-mp="3b27vukt006k0">
                        {number.display}
                      </a>
                    </li>)}
                </ul>
              </div>
            </li>
            <li data-id="element-58" data-mp="2w5qo03k0pa27">
              <a href={`mailto:${contactInfo.email}`} className="group flex items-center gap-4" data-id="element-59" data-mp="2w58jykr45rjq">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-60" data-mp="qcscgaw3zk4e">
                  <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="udc97dcrslq0" />
                </span>
                <span className="min-w-0" data-id="element-62" data-mp="23cn5eybu3fnz">
                  <span className="block text-sm text-ink/60" data-id="element-63" data-mp="239hgpk74afss">Correo</span>
                  <span className="block break-all text-lg font-medium transition-colors duration-150 ease-out group-hover:text-gold-deep" data-id="element-64" data-mp="1yaxtzhkp8zzd">
                    {contactInfo.email}
                  </span>
                </span>
              </a>
            </li>
            <li data-id="element-65" data-mp="2m2lbj8w2myoz">
              <a href={contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4" data-id="element-66" data-mp="2m10gzj9rbfr4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ink text-gold" data-id="element-67" data-mp="2d8gol0k267eq">
                  <InstagramIcon className="h-5 w-5" data-id="element-68" data-mp="28aeyvws4n9ua" />
                </span>
                <span data-id="element-69" data-mp="35qufeg6z8t4b">
                  <span className="block text-sm text-ink/60" data-id="element-70" data-mp="35s5jyi88y4wh">Instagram</span>
                  <span className="block text-lg font-medium transition-colors duration-150 ease-out group-hover:text-gold-deep" data-id="element-71" data-mp="30ykl6nytx6w8">
                    {contactInfo.instagramHandle}
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>

        <ContactForm data-id="element-72" data-mp="3i7lsnlen8gui" />
      </div>
    </section>;
}